import Vue from 'vue'
import Router from 'vue-router'
import cognito from '@/cognito'
import store from '@/store'
import routes from './routes'
import site from '@/util/site'
import { Firebase, Admin } from '@/api'

Vue.use(Router)

const adminSignOut = (to, from, next) => {
  cognito.signOut()
  next('/admin/signin')
}

routes.push({
  path: '/admin/signout',
  beforeEnter: adminSignOut,
})

const router = new Router({
  mode: 'history',
  saveScrollPosition: true,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
})

router.beforeEach(async(to, from, next) => {
  const isAdminPath = to.path.startsWith('/admin')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (isAdminPath) {
    // Admin User Auth
    let session
    try {
      store.dispatch('setLoading', true)
      session = await cognito.isAuthenticated()
      store.dispatch('setLoading', false)
    } catch (err) {
      //console.log(err)
      store.dispatch('setAdminUser', null)
      store.dispatch('setLoading', false)
    }
    if (!session) {
      if (requiresAuth) {
        const signInPath = '/admin/signin'
        let nextRoute = { path: signInPath }
        if (to.name !== 'AdminTop') {
          nextRoute.query = { redirect: to.fullPath }
        }
        next(nextRoute)
      } else {
        next()
      }
    } else {
      try {
        store.dispatch('setLoading', true)
        const token = session.idToken.jwtToken
        const res = await cognito.getAttribute()
        let attrs = {}
        for(let v of res) {
          let key = v.getName().replace(/^custom\:/g, '')
          attrs[key] = v.getValue()
        }
        const user = {
          username: cognito.currentUser.username,
          attributes: attrs,
          token: token,
          accessToken: session.accessToken.jwtToken,
          refreshToken: session.refreshToken.token,
        }
        store.dispatch('setAdminUser', user)
        store.dispatch('setLoading', false)
        if (to.matched.some(record => record.meta.requiresRoleAdmin)) {
          if (store.getters.hasAdminRole() === false) {
            next({ path: '/error/forbidden' })
          }
        }
        if (to.matched.some(record => record.meta.requiresAcceptService)) {
          let allowedServiceIds = store.state.adminUserAllowedServiceIds
          if (allowedServiceIds.length === 0) {
            store.dispatch('setLoading', true)
            const services = await Admin.getAccountServices(null, token)
            allowedServiceIds = services.map(item => item.serviceId)
            store.dispatch('setAdminUserAllowedServiceIds', allowedServiceIds)
            store.dispatch('setLoading', false)
          }
          if (allowedServiceIds.includes(to.params.serviceId) === false) {
            next({ path: '/error/forbidden' })
          }
        }
      } catch (err) {
        //console.log(err)
        store.dispatch('setAdminUser', null)
        store.dispatch('setLoading', false)
        adminSignOut(to, from, next)
      }
      next()
    }
  } else {
    // User Auth
    const signInPath = '/signin'
    let user = Firebase.getCurrentUser()
    if (!user) {
      user = await Firebase.onAuthStateChanged()
    }
    store.dispatch('setUser', site.convUserObjForStore(user))
    if (user) {
      if ([signInPath, '/signup', '/password-reset', '/password-reset/sent'].includes(to.path)) {
        next({ name:'UserTop' })
      } else {
        //if (!store.getters.isEmailVerified) {
        //  next({ name:'RequiredEmailVerification' })
        next()
      }
    } else {
      if (requiresAuth) {
        next({
          path: signInPath,
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    }
  }
  store.dispatch('setHeaderMenuOpen', false)
})

export default router
